export const commonValues = {
  successfulPasses: {
    name: 'statistic_fields.player_and_team.successful_passes',
    categoryIds: [2, 20],
    position: 1,
    coordinatePoint: 3,
    isNegative: false,
    generalName: 'Pases acertados',
    singleName: 'Pase acertado',
  },
  unsuccessfulPasses: {
    name: 'statistic_fields.player_and_team.unsuccessful_passes',
    categoryIds: [3, 21],
    position: 2,
    coordinatePoint: 3,
    isNegative: true,
    generalName: 'Pases no acertados',
    singleName: 'Pase no acertado',
  },
  recoveredBalls: {
    name: 'statistic_fields.player_and_team.balls_recovered',
    categoryIds: [482],
    position: 3,
    coordinatePoint: 1,
    isNegative: false,
    generalName: 'Balones recuperados',
    singleName: 'Balón recuperado',
  },
  lostBalls: {
    name: 'statistic_fields.player_and_team.balls_lost',
    categoryIds: [493],
    position: 4,
    coordinatePoint: 3,
    isNegative: true,
    generalName: 'Balones perdidos',
    singleName: 'Balón perdido',
  },
};

export const goalkeeperValues = {
  successfulFistFootClearance: {
    name: 'statistic_fields.goalkeeper.successful_punt_throw',
    categoryIds: [304, 306],
    position: 1,
    coordinatePoint: 3,
    isNegative: false,
    generalName: 'Despejes mano/pie acertadoa',
    singleName: 'Despeje mano/pie acertado',
  },
  unsuccessfulFistFootClearance: {
    name: 'statistic_fields.goalkeeper.unsuccessful_punt_throw',
    categoryIds: [305, 307],
    position: 2,
    coordinatePoint: 3,
    isNegative: true,
    generalName: 'Despejes mano/pie no acertados',
    singleName: 'Despeje mano/pie no acertado',
  },
  successfulFootPlay: {
    name: 'statistic_fields.goalkeeper.successful_footwork',
    categoryIds: [310, 308],
    position: 3,
    coordinatePoint: 3,
    isNegative: false,
    generalName: 'Juego de pie acertados',
    singleName: 'Juego de pie acertado',
  },
  unsuccessfulFootPlay: {
    name: 'statistic_fields.goalkeeper.unsuccessful_footwork',
    categoryIds: [311, 309],
    position: 4,
    coordinatePoint: 3,
    isNegative: true,
    generalName: 'Juego de pie no acertados',
    singleName: 'Juego de pie no acertado',
  },
};
